// @flow

import React, { Component } from 'react';
import numeral from 'numeral';
import glamorous, { Div } from 'glamorous';
import Hitbtc from 'app/images/exchanges/hitbtc.png';
import Latoken from 'app/images/exchanges/latoken.png';
import Playxchange from 'app/images/exchanges/playxchange.png';
import IndependentReserve from 'app/images/exchanges/independent_reserve.png';
import { PlayChip } from '../../components/styled/currencyIcons';
import GridItem from './GridItem';

type Props = {
  balance?: number,
  className?: Object
};

const Wrapper = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  color: 'black',
  height: '100%'
});

const Header = glamorous.div(
  {
    textAlign: 'center',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  ({ theme }) => ({
    padding: theme.spacing.small,
    backgroundColor: theme.color.primary,
    fontSize: theme.fontSize.small,
    color: theme.color.white
  })
);

const Content = glamorous.div(
  {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column'
  },
  ({ theme }) => ({
    padding: theme.spacing.small,
    [theme.mediaQuery.desktopAndUp]: {
      flexDirection: 'row'
    }
  })
);

const Footer = glamorous.div(
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 50,
    color: 'white'
  },
  ({ theme }) => ({
    padding: theme.spacing.small,
    backgroundColor: theme.color.basis3
  })
);

const Box = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.basis2,
  borderRadius: 8,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 1,
  padding: theme.spacing.small,
  maxHeight: 150
}));

const TextContainer = glamorous.div(({ theme, expanded }) => ({
  flexBasis: expanded ? '75%' : '50%',
  padding: theme.spacing.small,
  '& a': {
    color: 'blue'
  }
}));

const StyledPlayChip = glamorous(PlayChip)({
  width: 84,
  height: 'auto'
});

const Chevron = glamorous.span(
  {
    fontSize: '0.66em',
    marginLeft: 4,
    marginTop: -2
  },
  ({ expanded }) => (expanded ? 'ion-chevron-up' : 'ion-chevron-down')
);

const Button = glamorous.button({
  // outline: 'none',
});

const ImageContainer = glamorous.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  alignContent: 'space-between',
  justifyContent: 'space-between',
  '& > img, & > a > img': {
    padding: '0.5em',
    maxWidth: '190px'
  },
  [theme.mediaQuery.mobilePortraitOnly]: {
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

class CashOutSoon extends Component<Props> {
  props: Props;

  state = {
    expanded: false
  };

  static defaultProps = {
    balance: undefined,
    className: undefined
  };

  render() {
    const { className, balance } = this.props;
    const { expanded } = this.state;
    return (
      <GridItem big expanded={expanded}>
        <Wrapper className={className}>
          <Header>Coming Soon</Header>
          <Content>
            <Box>
              <StyledPlayChip />
            </Box>
            <TextContainer expanded={expanded}>
              <p>
                <strong>Coming Soon:</strong> Exchange your PlayChips for cash, Bitcoin or Ethereum.
              </p>
              {expanded && (
                <span>
                  <p>
                    PlayChip Fantasy is revolutionizing the Fantasy Sports and gaming industry by
                    shifting to the blockchain.
                  </p>
                  <p>
                    This means that soon you’ll be able to exchange your PlayChips through one of
                    our partner exchanges for cash or other crypto once we have made the transition.
                  </p>
                  <p>
                    So keep playing and earning your PlayChips. We will let you know as soon as the
                    withdraw feature has been turned on which will be in early 2019.
                  </p>
                  <p>
                    For more information please go to{' '}
                    <a
                      href="https://www.playchip.global/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.playchip.global
                    </a>{' '}
                    or{' '}
                    <a
                      href="https://www.playxchange.global/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.playxchange.global
                    </a>{' '}
                    or find us here on{' '}
                    <a
                      href="https://t.me/PlayChipTokenSale"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      telegram
                    </a>
                    .
                  </p>
                  <ImageContainer>
                    <a
                      href="https://www.playxchange.global/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img alt="" src={Playxchange} />
                    </a>
                    <a
                      href="https://www.independentreserve.com/invite/NCVSDB"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img alt="" src={IndependentReserve} />
                    </a>
                    <img alt="" src={Hitbtc} />
                    <img alt="" src={Latoken} />
                  </ImageContainer>
                </span>
              )}
            </TextContainer>
          </Content>
          <Footer>
            {balance !== undefined && (
              <Div flexGrow={1}>Cash Out: USD{numeral(balance / 100).format('$0,0.[00]')}</Div>
            )}
            <Button
              onClick={() => {
                this.setState(state => ({ expanded: !state.expanded }));
              }}
            >
              <span>
                {expanded ? 'less info' : 'more info'}
                <Chevron expanded={expanded} />
              </span>
            </Button>
          </Footer>
        </Wrapper>
      </GridItem>
    );
  }
}

export default CashOutSoon;
